import json from "../../package.json";
const version = json.version;

export const getVersion = function () { return version; };